import api, { ApiResponse } from './api';

import {
  Invoice,
  ExtractInvoiceProps,
  InvoiceDataProps,
  CreateInvoiceProps,
  GetInvoiceProps,
} from 'entities/Invoice';

interface GetInvoiceListResponse {
  success: boolean;
  data: Invoice[];
}

export const getInvoiceListService = (): ApiResponse<GetInvoiceListResponse> =>
  api({ method: 'GET', url: 'invoices', useToken: true });

interface GetInvoiceResponse {
  success: boolean;
  data: Invoice;
}

export const getInvoiceService = (
  data: GetInvoiceProps
): ApiResponse<GetInvoiceResponse> =>
  api({ method: 'get', url: `invoices/${data.id}`, useToken: true });

interface ExtractInvoiceResponse {
  success: boolean;
  data: InvoiceDataProps;
}

export const extractInvoiceDataService = ({
  file,
  documentNumber,
}: ExtractInvoiceProps): ApiResponse<ExtractInvoiceResponse> => {
  const data = new FormData();
  data.append('file', file);
  // Reenvio de PDF protegido: manda o CPF/CNPJ digitado para o backend derivar a
  // senha (5/4 primeiros dígitos). Ausente no primeiro envio.
  if (documentNumber) data.append('documentNumber', documentNumber);

  return api({
    method: 'post',
    url: 'extract-invoices',
    data,
    useToken: true,
    hasFile: true,
  });
};

interface CreateInvoiceResponse {
  success: boolean;
  data: Invoice;
}

export const createInvoiceService = (
  data: CreateInvoiceProps
): ApiResponse<CreateInvoiceResponse> =>
  api({
    method: 'post',
    url: 'invoices',
    data,
    useToken: true,
  });

interface RunInvoiceBulkResponse {
  success: boolean;
  data: number;
}

export const runInvoiceBulkService = (): ApiResponse<RunInvoiceBulkResponse> =>
  api({
    method: 'post',
    url: 'invoice-bulk',
    useToken: true,
  });

interface DeleteInvoiceResponse {
  success: boolean;
}

export const deleteInvoiceService = (
  id: string
): ApiResponse<DeleteInvoiceResponse> =>
  api({
    method: 'delete',
    url: `invoices/${id}`,
    useToken: true,
  });
